import auth from './modules/auth'
import logs from './modules/logs'
import mfa from './modules/mfa'

export default {
    auth,
    logs,
    mfa
}
